// extracted by mini-css-extract-plugin
module.exports = {"styledForeign":"FEOUK58J","circleIcon":"g7b3QeHT","circleRingIcon":"dMHg6KpI","labelWrapper":"eziLfkMn","date":"_RgCMbSD","value":"dinem_Mg"};